import { CheckoutStatusResponse } from "@ssc-booking/api-contracts"
import * as DateTime from "@silversea-ssc/data-types/DateTime"
import { priceResponse } from "../../../test-support/common"
import availableSuites from "./available-suites"
import { cruiseCode } from "./cruisecode"

const validatedPrice = priceResponse(cruiseCode, "CV", { depositPercentage: 25, totalAmount: 11600 })
export default CheckoutStatusResponse.of.started({
    bookingNumber: "71459-22",
    suitePayment: validatedPrice.suitePayment,
    validatedPrice,
    suiteNumber: availableSuites.suites[0].number,
    flowType: "ECommerce",
    expiration: DateTime.addDays(DateTime.now(), 7),
})
